import { render } from "./QuestionScreen.vue?vue&type=template&id=21d16f6e"
import script from "./QuestionScreen.vue?vue&type=script&lang=ts"
export * from "./QuestionScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script